module.exports = __webpack_public_path__ + "static/media/desktop_nformacy_logo.a4ad62a0.svg";